import { PanelBar } from "@progress/kendo-react-layout/dist/npm/panelbar/PanelBar";
import { PanelBarItem } from "@progress/kendo-react-layout/dist/npm/panelbar/PanelBarItem";
import classes from "src/pages/Home/components/Forms/TimberlandAppraisalForm/TimberlandAppraisal.module.scss";
import { IFormSettingModel } from "../../../../../interfaces/form-settings.interface";
import { IFormEntryModel } from "../../../../../interfaces/form-entry.interface";
import { useEffect, useRef, useState } from "react";
import { SelectedFormType } from "../../../../../context/SelectedForm/selected-form-reducer";
import { GenericActionType } from "../../../../../context/generic-actions.type";
import { DatePickerChangeEvent, CalendarChangeEvent, DatePicker } from "@progress/kendo-react-dateinputs";
import { CheckboxChangeEvent, TextAreaChangeEvent, InputChangeEvent, NumericTextBoxChangeEvent, Input } from "@progress/kendo-react-inputs";
import { Label, Error } from "@progress/kendo-react-labels";
import { MMddyyyyDateFormat } from "src/constants/date-formats";
import { ITimberlandAppraisalFormSixthSection } from "src/interfaces/forms/TimberlandAppraisalForm/timberland-appraisal-form-sixth-section.interface";
import { FormValidation } from "../InputValidator";
import SectionTitle from "../Shared/SectionTitle";

interface GeneralFormType {
    isAdminPreview?: boolean,
    setFormDataFields: (form: ITimberlandAppraisalFormSixthSection) => void;
    formDataFields?:  ITimberlandAppraisalFormSixthSection,
    formSettings?: IFormSettingModel,
    formEntry?: IFormEntryModel,
    setFormIsValid: (value: boolean) => void,
    selectedFormDispatch: (value: GenericActionType<SelectedFormType>) => void,
}

export default function TimberlandAppraisalFormSixthSection(props: GeneralFormType): JSX.Element {
    const { formDataFields, setFormDataFields, formSettings, setFormIsValid } = props;
    const [isValid, setIsValid] = useState<boolean>(false);
    const [isFormTouched, setIsFormTouched] = useState<boolean>(false);
    const formRef = useRef<HTMLFormElement>(null);
    const { validationMessage, inputValidator } = FormValidation(formRef);
    const title = <SectionTitle isFormTouched={isFormTouched} isValid={isValid} number={6} name={"Signature"}/>;

    function changeValueHandler(
        event:
            | CheckboxChangeEvent
            | DatePickerChangeEvent
            | TextAreaChangeEvent
            | InputChangeEvent
            | CalendarChangeEvent
            | NumericTextBoxChangeEvent,
        field: string,
    ) {
        if (field == "SignatureDate"){
            setFormDataFields({
                ...formDataFields,
                [field]: event.value?.toString()
            });
        } else if (field == "Signature") {
            setFormDataFields({
                ...formDataFields,
                [field]: event.value?.toString(),
                SignatureDate: new Date().toDateString()
            });
        } else {
            setFormDataFields({
                ...formDataFields,
                [field]: event.value
            });
        }
    }

    function changeValidator() {
        if (formRef.current) {
            setIsValid(formRef.current.checkValidity());
            setFormIsValid(formRef.current.checkValidity());
        }
    }

    function onTouch() {
        if (!isFormTouched) {
            setIsFormTouched(true);
        }
    }

    useEffect(() => {
        changeValidator()
    }, [formDataFields, formRef.current]);


    return <>
        <PanelBar keepItemsMounted={true}>
            <PanelBarItem title={title} expanded={true}>
                <form name={"Name"} className={classes.sectionForm} ref={formRef} onFocus={onTouch}>
                    <div className="container">
                        <div className={classes.item}>
                            <div className={classes.itemFields}>
                                <Label className={`${classes.Label} ${classes.fieldsGroupW100}`}>
                                    NOTICE REGARDING PENALTIES FOR MAKING OR FILING AN APPLICATION CONTAINING A FALSE STATEMENT: 
                                    If you make a false statement on this form, you could be found guilty of a Class A 
                                    misdemeanor or a state jail felony under Penal Code Section 37.10.
                                </Label>
                            </div>
                            <div className={classes.itemFields}>
                                <Label className={`${classes.Label} ${classes.fieldsGroupW100}`}>
                                    By submitting this form you swear or affirm the following:
                                </Label>
                                <ul className="ng-scope">
                                    <li>that each fact contained in this application is true and correct;</li>
                                    <li>that the property the owner identified in this application meets the qualifications under Texas law for the exemption claimed; and</li>
                                    <li>that I have read and understand the Notice Regarding Penalties for Making or Filing an Application Containing a False Statement.</li>
                                </ul>
                            </div>
                            <div className={classes.itemFields}>
                                <div className={classes.fieldsGroupW60}>
                                    <Label className={`${classes.Label}`}>
                                        Signature of Property Owner or Authorized Representative
                                        {!formDataFields?.Signature && (
                                            <i className={"fa fa-asterisk text-danger"}></i>
                                        )}
                                    </Label>
                                    <Input
                                        required={true}
                                        name={"Signature"}
                                        placeholder={"Signature of Property Owner or Authorized Representative"}
                                        disabled={formSettings?.isReadOnly}
                                        className={classes.kTextbox}
                                        value={formDataFields?.Signature}
                                        onChange={e => changeValueHandler(e, "Signature")}
                                    />
                                    {!inputValidator("Signature") && (
                                        <Error >{validationMessage}</Error>
                                    )}
                                </div>
                                <div className={classes.fieldsGroupW30}>
                                    <Label className={`${classes.Label}`}>
                                        Date Signed
                                        {!formDataFields?.SignatureDate && (
                                            <i className={"fa fa-asterisk text-danger"}></i>
                                        )}
                                    </Label>
                                    <DatePicker
                                        format={MMddyyyyDateFormat}
                                        name={"SignatureDate"}
                                        required={true}
                                        disabled={true}
                                        className={classes.kTextbox}
                                        value={formDataFields?.SignatureDate ? new Date(formDataFields?.SignatureDate) : undefined}
                                        onChange={e => changeValueHandler(e, "SignatureDate")}
                                    />
                                    {!inputValidator("SignatureDate") && (
                                        <Error >{validationMessage}</Error>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </PanelBarItem>
        </PanelBar>
    </>
}
